'use client';

import React from 'react';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterBarProps {
  categories: FilterOption[];
  styles: FilterOption[];
  selectedCategory: string;
  selectedStyle: string;
  onCategoryChange: (category: string) => void;
  onStyleChange: (style: string) => void;
}

const FilterBar: React.FC<FilterBarProps> = ({
  categories,
  styles,
  selectedCategory,
  selectedStyle,
  onCategoryChange,
  onStyleChange
}) => {
  return (
    <div data-component-id="src/app/installation-gallery/components/FilterBar.tsx:28:4" data-component-path="src/app/installation-gallery/components/FilterBar.tsx" data-component-line="28" data-component-end-line="62" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20gap-4%22%7D" className="flex flex-col gap-4">
      {/* Category Filters */}
      <div data-component-id="src/app/installation-gallery/components/FilterBar.tsx:30:6" data-component-path="src/app/installation-gallery/components/FilterBar.tsx" data-component-line="30" data-component-end-line="44" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
        {categories?.map((category) => (
          <button data-component-id="src/app/installation-gallery/components/FilterBar.tsx:32:10" data-component-path="src/app/installation-gallery/components/FilterBar.tsx" data-component-line="32" data-component-end-line="42" data-component-file="FilterBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={category.value}
            onClick={() => onCategoryChange(category.value)}
            className={`px-6 py-3 font-body text-sm tracking-wide transition-all duration-300 rounded-lg ${
              selectedCategory === category.value
                ? 'bg-accent text-accent-foreground shadow-sm'
                : 'bg-muted text-foreground hover:bg-accent/50 hover:text-accent-foreground'
            }`}
          >
            {category.label}
          </button>
        ))}
      </div>

      {/* Style Filters */}
      <div data-component-id="src/app/installation-gallery/components/FilterBar.tsx:47:6" data-component-path="src/app/installation-gallery/components/FilterBar.tsx" data-component-line="47" data-component-end-line="61" data-component-file="FilterBar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20gap-3%22%7D" className="flex flex-wrap gap-3">
        {styles?.map((style) => (
          <button data-component-id="src/app/installation-gallery/components/FilterBar.tsx:49:10" data-component-path="src/app/installation-gallery/components/FilterBar.tsx" data-component-line="49" data-component-end-line="59" data-component-file="FilterBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={style.value}
            onClick={() => onStyleChange(style.value)}
            className={`px-6 py-3 font-body text-sm tracking-wide transition-all duration-300 rounded-lg ${
              selectedStyle === style.value
                ? 'bg-accent text-accent-foreground shadow-sm'
                : 'bg-muted text-foreground hover:bg-accent/50 hover:text-accent-foreground'
            }`}
          >
            {style.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;
